/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { selectPlanScroller } from 'services/PageScroller'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import { setScrollElementId } from 'redux-app/modules/pageScroller'
import { ITEM_NAMES, MENU_ITEMS } from './constants'
import Footer from './Footer'

export default compose(
  connect(
    null,
    {
      setScrollElementId,
    },
  ),
  withLocalization('footer'),
  withRouter,
  withHandlers({
    onClickMenuItem: ({ history, t, setScrollElementId }) => (event, name) => {
      event.preventDefault()
      if (name === ITEM_NAMES.plans) {
        history.push(ROUTES.home.home)
        setScrollElementId(selectPlanScroller.getElementId())
        return
      }
      const itemConfig = MENU_ITEMS.find(item => item.name === name)
      if (itemConfig) {
        window.open(t(itemConfig.linkPath), '_blank')
      }
    },
  }),
)(Footer)
